import { useMemo } from 'react';
import { useSelector } from 'react-redux';

function selectLoadedEvents(state) {
    return state.events.loadedEvents;
}

function selectEventsData(state) {
    return state.events;
}

export function useLoadedEvents() {
    const loadedEvents = useSelector(selectLoadedEvents),
        eventsData = useSelector(selectEventsData);

    return useMemo(() => {
        return loadedEvents.map((eventId) => eventsData[eventId].event);
    }, [loadedEvents, eventsData]);
}
